import { render, staticRenderFns } from "./learningEffectiveness.vue?vue&type=template&id=9ca37fba"
import script from "./learningEffectiveness.vue?vue&type=script&lang=js"
export * from "./learningEffectiveness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports